Alpine.data('alpine_prevent_double_submit', () => ({
  submitted: false,
  checkSubmit(event) {
      if(this.submitted) {
          event.preventDefault();
          return false;
      }

      this.submitted = true;
  },
}));
